import React from "react";
import { Button, Modal, Form, Input, Select, message } from "antd";
import { addBankCards } from '@/api/wallet';

const clsPrefix = 'bankCard';

const Option = Select.Option;
const bankList = [
  "中国银行", "中国工商银行", 
  "中国农业银行", "中国建设银行",
  "招商银行", "广东发展银行", 
  "中信银行", "中国民生银行", 
  "交通银行"
];
const formItems = [
  {
    label: '支行名',
    field: 'bankBranchName',
    rules: [{
      required: true,
      message: '请输入支行名!'
    }]
  },
  {
    label: '银行卡账号',
    field: 'bankAccountNo',
    placeholder: '请输入不超过20个字',
    rules: [{
      required: true,
      message: '请输入银行卡账号!'
    }]
  },
  {
    label: '身份证姓名',
    field: 'certName',
    rules: [{
      required: true,
      message: '请输入身份证姓名!'
    }]
  },
  {
    label: '身份证号',
    field: 'certNo',
    rules: [{
      required: true,
      pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: '请输入正确的身份证号!'
    }]
  },
  {
    label: '手机号',
    field: 'phone',
    rules: [{
      required: true,
      len: 11,
      message: '请输入正确手机号!'
    }]
  },
  {
    label: '省份',
    field: 'province',
    rules: [{
      required: true,
      message: '请输入省份!'
    }]
  },
  {
    label: '城市',
    field: 'city',
    rules: [{
      required: true,
      message: '请输入城市!'
    }]
  },
];

const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 13 },
}

// 修改银行卡信息表单
const CollectionCreateForm = Form.create()(
  class extends React.Component {
    render() {
      const { visible, onCancel, onCreate, form } = this.props;
      const { getFieldDecorator } = form;
      return (
        <Modal
          visible={visible}
          title="添加银行卡"
          okText="确认"
          onCancel={onCancel}
          onOk={onCreate}
        >
          <Form layout="horizontal">
            <Form.Item label="发卡银行" {...formItemLayout}>
              {getFieldDecorator("bankName", {
                rules: [{ required: true, message: "请输入选择银行!" }]
              })(
                <Select>
                  {
                    bankList.map(bank => (
                      <Option value={bank}>{bank}</Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
            {
              formItems.map(form => (
                <Form.Item label={form.label} {...formItemLayout}>
                  {getFieldDecorator(form.field, {
                    rules: form.rules
                  })(
                    <Input placeholder={form.placeholder} />
                  )}
                </Form.Item>
              ))
            }
          </Form>
        </Modal>
      );
    }
  }
);
  
// 新增银行卡按钮
class Cardedit extends React.Component {
  state = {
    visible: false
  };

  showModal = () => {
    this.setState({ visible: true });
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  handleCreate = () => {
    const form = this.formRef.props.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      addBankCards(values).then(() => {
        message.info('添加银行卡成功');
        this.props.onAdd(values);
      });
      form.resetFields();
      this.setState({ visible: false });
    });
  };

  saveFormRef = formRef => {
    this.formRef = formRef;
  };
  
  render() {
      return (
        <div>
          <Button className={`${clsPrefix}-addBankBtn`} type="primary" onClick={this.showModal}>
            + 新增银行卡
          </Button>
          <CollectionCreateForm
            wrappedComponentRef={this.saveFormRef}
            visible={this.state.visible}
            onCancel={this.handleCancel}
            onCreate={this.handleCreate}
          />
        </div>
      );
  }
}
export default Cardedit;